import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.claims;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//get accidentClaims
const getAllAccidentClaims = async () => {
    let response;
    await axios.get(baseUrl.accident + 'claim/claims')
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const getAllAccidentInjuryClaims = async () => {
    let response;
    await axios.get(baseUrl.accident_injury_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}
const getAllAccidentDeathClaims = async () => {
    let response;
    await axios.get(baseUrl.accident_death_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get funeralClaims
const getAllFuneralClaims = async () => {
    let response;
    await axios.get(baseUrl.funeral.get, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get comprehensiveClaims
const getAllComprehensiveClaims = async () => {
    let response;
    await axios.get(baseUrl.comprehensive.get, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get savingsClaims
const getAllWithdrawals = async () => {
    let response;
    await axios.get(baseUrl.savings.get_withdrawals, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res)
            response = res;
        })
        .catch(err => {
            console.log(err)
            response = err;
        });

    return response;
}

const getAllSurrenders = async () => {
    let response;
    await axios.get(baseUrl.savings.get_surrenders, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllMatured = async () => {
    let response;
    await axios.get(baseUrl.savings.get_refund_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllSavingsMaturity = async () => {
    let response;
    await axios.get(baseUrl.savings.get_maturity, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllDeathClaims = async () => {
    let response;
    await axios.get(baseUrl.savings.get_death_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get inothoClaims
const getAllInothoWithdrawals = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_withdrawals, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res)
            response = res;
        })
        .catch(err => {
            console.log(err)
            response = err;
        });

    return response;
}

const getAllInothoSurrenders = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_surrenders, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllInothoRefund = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_refund_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllInothoDeathClaims = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_death_claims, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllHospitalCash = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_hospital_cash, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllPersonalAccident = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_personal_accident, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllFuneralCash = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_funeral_cash, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getAllInothoMaturity = async () => {
    let response;
    await axios.get(baseUrl.inotho.get_maturity, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

// add inotho claims
const inothoMaturity = async (request) => {
    let response;

    await axios.post(baseUrl.inotho.post_maturity, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}
const inothoWithdrawal = async (request) => {
    let response;

    await axios.post(baseUrl.inotho.post_withdrawal, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoDeathClaim = async (data) => {
    let response;

    console.log("data: ", data)
    await axios.post(baseUrl.inotho.post_death_claim, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoRefund = async (request) => {
    let response;
    await axios.post(baseUrl.inotho.post_refund_claim, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoSurrender = async (request) => {
    let response;
    await axios.post(baseUrl.inotho.post_surrender, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoHospitalCash = async (data) => {
    let response;

    console.log("data: ", data)
    await axios.post(baseUrl.inotho.post_hospital_cash, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoPersonalAccident = async (request) => {
    let response;
    await axios.post(baseUrl.inotho.post_personal_accident, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const inothoFuneralCash = async (request) => {
    let response;
    await axios.post(baseUrl.inotho.post_funeral_cash, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add accidentClaim
const addAccidentClaim = async (request) => {
    let response;

    console.log("data: ", request);

    await axios.post(baseUrl.accident_injury_claim + 'save-claim', request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res.status);
            response = res;
        }).catch(err => {
            console.log("status: ", err);
            response = err;
        });
    return response;
}

//add accidentDeathClaim
const addAccidentDeathClaim = async (request) => {
    let response;

    console.log("data: ", request);

    await axios.post(baseUrl.accident_death_claim + 'save-claim', request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add funeralClaims
const addFuneralClaim = async (data) => {
    let response;


    await axios.post(baseUrl.funeral.post + 'save-claim', data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add comprehensiveClaims
const addComprehensiveClaim = async (data) => {
    let response;

    console.log("data: ", data)
    await axios.post(baseUrl.comprehensive.post + 'save-claim', data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add savingsClaims
const newWithdrawal = async (request) => {
    let response;

    await axios.post(baseUrl.savings.post_withdrawal, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//add savingDeathClaims
const savingsDeathClaim = async (data) => {
    let response;

    console.log("data: ", data)
    await axios.post(baseUrl.savings.post_death_claim, data, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const mature = async (request) => {
    let response;
    await axios.post(baseUrl.savings.post_refund_claim, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const newMaturity = async (request) => {
    let response;
    await axios.post(baseUrl.savings.post_maturity, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const newSurrender = async (request) => {
    let response;
    await axios.post(baseUrl.savings.post_surrender, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update claims
const validateClaim = async (id) => {
    let response;
    await axios.post(baseUrl.update.validate + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const suspendClaim = async (id) => {
    let response;
    await axios.post(baseUrl.update.suspend + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const AuthorizeClaim = async (id) => {
    let response;
    await axios.post(baseUrl.update.authorise + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const RejectClaim = async (id) => {
    let response;
    await axios.post(baseUrl.update.reject + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const InitiatePay = async (id) => {
    let response;
    await axios.post(baseUrl.update.initiate + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const Pay = async (id) => {
    let response;
    await axios.post(baseUrl.update.pay + id, {}, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const updateClaim = async (request) => {
    let response;
    await axios.post(baseUrl.update_claim + request.id, request, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(res => {
        console.log("server response: ", res);
        response = res;
    })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const updateClaimFile = async (request) => {
    let response;
    await axios.post(baseUrl.update_claim_file + request.id, {
        'file': request.file
    }, {
        headers: {Authorization: `Bearer ${token}`}
    }).then(res => {
        console.log("server response: ", res);
        response = res;
    })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}


export default {
    getAllAccidentClaims,
    getAllComprehensiveClaims,
    getAllWithdrawals,
    getAllSurrenders,
    getAllFuneralClaims,
    getAllInothoSurrenders,
    getAllInothoDeathClaims,
    getAllInothoWithdrawals,
    getAllPersonalAccident,
    getAllInothoRefund,
    getAllHospitalCash,
    getAllFuneralCash,
    addAccidentClaim,
    addAccidentDeathClaim,
    newSurrender,
    newWithdrawal,
    addComprehensiveClaim,
    addFuneralClaim,
    inothoSurrender,
    inothoWithdrawal,
    inothoFuneralCash,
    inothoPersonalAccident,
    inothoDeathClaim,
    inothoRefund,
    inothoHospitalCash,
    validateClaim,
    AuthorizeClaim,
    RejectClaim,
    InitiatePay,
    Pay,
    suspendClaim,
    savingsDeathClaim,
    mature,
    getAllMatured,
    getAllDeathClaims,
    getAllAccidentInjuryClaims, getAllAccidentDeathClaims,
    updateClaim,
    updateClaimFile,
    getAllInothoMaturity,
    getAllSavingsMaturity,
    newMaturity,
    inothoMaturity
}
